/**
 * Single source of truth for the Organization / LocalBusiness schema.
 * Values are the legal entity's, not the brand's, where the two differ —
 * the footer already renders „Глоуб Систем” ООД as the copyright holder.
 *
 * Address and hours confirmed by the client (Sofia, Iskarsko shose 11,
 * Mon–Fri 08:30–17:30). Geo omitted until coordinates are supplied.
 */
export const ORGANIZATION = {
  legalName: 'Глоуб Систем ООД',
  name: 'Vodi4ka',
  telephone: '+359 2 946 3202',
  email: 'info@vodi4ka.com',
  logoPath: '/images/logo/logo-vodi4ka-social.png',
  sameAs: [
    'https://www.facebook.com/vodi4ka.com1',
    'https://www.instagram.com/www_vodi4ka_com/',
    'https://www.youtube.com/@vodi4ka_com',
    'https://www.tiktok.com/@r_3535978',
  ],
  address: {
    streetAddress: 'бул. Искърско шосе 11',
    addressLocality: 'София',
    addressCountry: 'BG',
  },
  openingHours: {
    days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'] as const,
    opens: '08:30',
    closes: '17:30',
  },
} as const
